import { IconButton, InputBase, Paper, Theme, makeStyles } from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';
import React from 'react';

interface Props {
    value?: string;
    onChange?: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> | undefined;
    onKeyUp?: React.KeyboardEventHandler<HTMLTextAreaElement | HTMLInputElement> | undefined;
    placeholder?: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

function SearchField(props: Props) {

    const classes = useStyles();

    return (
        <Paper className={classes.root}>
            <InputBase
                className={classes.input}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.onChange}
                onKeyUp={props.onKeyUp}
            />
            <IconButton className={classes.iconButton} onClick={props.onClick}>
                <SearchIcon />
            </IconButton>
        </Paper>
    );
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 400,
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },

}));

export default SearchField;